const initialState = {
  departments: {
    data: [],
    loading: false,
    error: null,
  },
};

export default initialState;
